import PropTypes from 'prop-types'
import { Route, Routes } from 'react-router-dom'
import PublicacionDetalle from './publicaciones/Detalle'
import BordeDetalle from './ui/BordeDetalle'

const ContenedorDetalle = (props) => {
  return (
    <>
      <Routes>
        {/* administración de Publicaciones */}

        {/* obtiene Publicaciones filtradas acorde a la búsqueda */}
        <Route
          path="/Publicaciones/:buscar?"
          element={
            <>
              <BordeDetalle
                titulo={'Detalle Publicación'}
                onCerrarClick={props.onCerrarClick}
              >
                <PublicacionDetalle {...props} />
              </BordeDetalle>
            </>
          }
        />
        {/* obtiene Publicaciones de cierta Tienda Oficial */}
        <Route
          path="/Publicaciones/TiendasOficiales/:idVendedor/:buscar?"
          element={
            <>
              <BordeDetalle
                titulo={'Detalle Publicación'}
                onCerrarClick={props.onCerrarClick}
                vieneDeTiendas={true}
              >
                <PublicacionDetalle {...props} />
              </BordeDetalle>
            </>
          }
        />
        {/* abre el detalle de una Publicación en particular */}
        <Route
          path="/Publicaciones/Detalle/:idPublicacion"
          element={
            <>
              <BordeDetalle
                titulo={'Detalle Publicación'}
                onCerrarClick={props.onCerrarClick}
              >
                <PublicacionDetalle {...props} />
              </BordeDetalle>
            </>
          }
        />
        {/* abre el detalle de una Publicación en particular en su subcategoria */}
        <Route
          path="/Publicaciones/Subcategorias/:idSubCategoria/:buscar?"
          element={
            <>
              <BordeDetalle
                titulo={'Detalle Publicación'}
                onCerrarClick={props.onCerrarClick}
              >
                <PublicacionDetalle {...props} />
              </BordeDetalle>
            </>
          }
        />
        <Route
          path="/Favoritos"
          element={
            <BordeDetalle
              titulo={'Detalle Publicación'}
              onCerrarClick={props.onCerrarClick}
            >
              <PublicacionDetalle {...props} />
            </BordeDetalle>
          }
        />
        {/* Abre el detalle de las publicaicones en oferta */}
        <Route
          path="/PublicacionesOfertas"
          element={
            <>
              <BordeDetalle
                titulo={'Detalle Publicación'}
                onCerrarClick={props.onCerrarClick}
              >
                <PublicacionDetalle {...props} />
              </BordeDetalle>
            </>
          }
        />
      </Routes>
    </>
  )
}

ContenedorDetalle.propTypes = {
  onCerrarClick: PropTypes.func.isRequired
}

export default ContenedorDetalle
